<template>
  <div class="discovery-item discovery-item-row" ref="item">
    <div class="discovery-item-row-left">
      <item-image :item="item" size="large" />
    </div>
    <div class="discovery-item-row-right">
      <a class="discovery-item-cover-image"
         :href="JsPAPI.util.itemURL(item, JsPAPI.api.getConfig())">
      <h2 class="discovery-item-title">{{ item.Title }}</h2>
      </a>
      <div v-if="item.Author" class="discovery-item-author">
        <a class="discovery-item-cover-image"
           :href="JsPAPI.util.authorURL(item, JsPAPI.api.getConfig())">
        {{ JsPAPI.util.cleanAuthor(item.Author) }}
        </a>
      </div>
      <div class="discovery-item-content">
        <div v-if="item.Summary" class="discovery-item-summary">
          {{ JsPAPI.util.truncate(item.Summary, 256) }}
        </div>
        <div class="discovery-item-details">
          <div class="discovery-item-description">
            <span class="discovery-item-label">{{ item.Description }}</span>
          </div>
          <div v-if="item.TargetAudience" class="discovery-item-published">
            <span class="discovery-item-label">Audience:</span> {{ item.TargetAudience }}
          </div>
          <div v-if="item.PublicationDate" class="discovery-item-published">
            <span class="discovery-item-label">Published:</span> {{ item.PublicationDate }}
          </div>
          <div class="discovery-item-availability">
            <span class="discovery-item-label">Available:</span> {{ item.SystemItemsIn }} of {{ item.SystemItemsTotal }}
          </div>
          <div class="discovery-item-callnumber">
            <span class="discovery-item-label">Call Number:</span> {{ item.CallNumber }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ItemImage from '@/components/ui/ItemImage.vue';

export default {
  name: 'RowsItem',
  data() {
    return {};
  },
  components: {
    ItemImage,
  },
  props: {
    item: {},
  },
};
</script>

<style lang="less">
.discovery-item-row {
  padding: 0.5rem;
  display: flex;
  gap: 1rem;
  .discovery-item-row-left {
    flex: 0 0 200px;
  }
  .discovery-item-row-right {
  }
  .discovery-item-details {
    margin-top: 0.5rem;
    font-size: 13pt;
  }
  .discovery-item-label {
    font-weight: bold;
  }
  .discovery-item-title {
    margin: 0;
  }
  .discovery-item-author {
    margin-bottom: 0.5rem;
  }
}
</style>
